import script from "./addAddressPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./addAddressPopup.vue?vue&type=script&lang=ts&setup=true"

import "./addAddressPopup.vue?vue&type=style&index=0&id=37161d1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37161d1a"]])

export default __exports__